import * as React from "react";
const SvgReturnCopy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18 10a8 8 0 0 0-8-8 8.67 8.67 0 0 0-5.991 2.436L2 6.444m4.444 0H2V2m0 8a8 8 0 0 0 8 8 8.67 8.67 0 0 0 5.991-2.436L18 13.556M18 18v-4.444h-4.444"
    />
  </svg>
);
export default SvgReturnCopy;
